import { Component, OnInit } from '@angular/core';
import { DialogConfig } from '@app/common/models/dialog-config';
import { DialogRef } from '@app/common/services/dialog-ref';

@Component({
  selector: 'create-case-select-owner-dialog',
  templateUrl: './create-case-select-owner-dialog.component.html',
})
export class CreateCaseSelectOwnerDialogComponent implements OnInit {

  ownershipsWithoutParent;
  ownershipsPossibleParents;

  constructor(
    private config: DialogConfig,
    private dialog: DialogRef,
  ) {
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  ngOnInit() {
    this.ownershipsWithoutParent = (this.config.data as any).ownershipsWithoutParent;
    this.ownershipsPossibleParents = (this.config.data as any).ownershipsPossibleParents;
  }

  onSubmit() {
    this.dialog.close(true);
  }

  onCancel() {
    this.dialog.close(false);
  }
}
